<template>
    <layout>
        <PageHeader :title="title" :items="items" />
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body">
                        <h4 class="card-title">Create a VL PT Round</h4>
                        <form ref="resForm" @submit.prevent="createPTRound">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label >PT Session</label>
                                        <multiselect v-model="pt_session" :options="options1" :multiple="false"></multiselect>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label >Month</label>
                                        <multiselect v-model="month" :options="options"  :multiple="false"></multiselect>
                                    </div>
                                </div>
                                <!--<div class="col-md-4">
                                    <div class="form-group">
                                        <label>Operator Name</label>
                                        <input type="text" placeholder="Operator Name" v-model="operator_name" class="form-control"/>
                                    </div>
                                </div>-->
                                <div class="col-md-6">
                                    <div class="form-group">
                                        <label>Choose site</label>
                                        <multiselect v-model="sValue" :options="options2" label="site_name" track-by="site_name" @remove="removed" :hide-selected="true" @select="selected" :close-on-select="false" :clear-on-select="true" :searchable="true" :multiple="true" >
                                        </multiselect>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <label> Year</label>
                                    <date-picker
                                            v-model="year"
                                            type="year"
                                            lang="en"
                                            placeholder="Select Year"
                                    ></date-picker>

                                </div>
                            </div>
                            <!--<div class="row" style="justify-content: space-between">
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Result Sample 1 </label>
                                        <input type="number"  v-model="results_sample1" class="form-control" placeholder="Enter Result 1"/>
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Result Sample 2</label>
                                        <input type="number"
                                               v-model="results_sample2"
                                               class="form-control"
                                               placeholder="Enter Result 2"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Result Sample 3</label>
                                        <input type="number"
                                               v-model="results_sample3"
                                               class="form-control"
                                               placeholder="Enter Result 3"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Result Sample 4</label>
                                        <input type="number"
                                               v-model="results_sample4"
                                               class="form-control"
                                               placeholder="Enter Result 4"
                                        />
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label>Result Sample 5</label>
                                        <input type="number"
                                               v-model="results_sample5"
                                               class="form-control"
                                               placeholder="Enter Result 5"
                                        />
                                    </div>
                                </div>
                            </div>-->
                            <button class="btn btn-primary" type="submit">Create</button>
                        </form>
                    </div>
                </div>
            </div>
            <div class="lodader__content" v-if="loader">
                <b-spinner style="width: 3rem; height: 3rem" class="loader" variant="success" label="Spinning"></b-spinner>
            </div>
        </div>
    </layout>
</template>

<script>
    import Layout from "../../layouts/main";
    import PageHeader from "@/components/page-header";
    import appConfig from "@/app.config";
    import Multiselect from "vue-multiselect";
    import DatePicker from "vue2-datepicker";
    import {axios_get, axios_post} from "../../../helpers/helper";

    export default {
        page: {
            title: "Create VL PT Round",
            meta: [{ name: "description", content: appConfig.description }]
        },
        components: { Layout, Multiselect,DatePicker,PageHeader },
        data() {
            return {
                site_ids : [],
                sValue : [],
                loader: false,
                title: "Create PT Round",
                user: null,
                items: [
                    {
                        text: "VL PT Round",
                        href: "/view-pt-rounds"
                    },
                    {
                        text: "Create VL PT Round",
                        active: true
                    }
                ],

                options: [
                    "January",
                    "Febuary",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                options1: [
                    "SESSION1",
                    "SESSION2",
                    "SESSION3",
                    "SESSION4",
                    "SESSION5",
                ],
                options2: [],
                value:[],
                pt_session:null,
                results_sample1:"",
                results_sample2:"",
                results_sample3:"",
                results_sample4:"",
                results_sample5:"",
                choose_site:[],
                value1: null,
                value2: null,
                month: null,
                year:null,
                operator_name:null,
            };

        },
        validations: {

        },
        methods: {
            createPTRound(){
                this.loader=true
                axios_post("/pt_rounds",{
                    pt_session:this.pt_session,
                    site_ids:this.site_ids,
                    pt_type:'VL',
                    month:this.month,
                    country_id: this.user.country_id,
                    operator_name: this.operator_name,
                    results_sample1:0,
                    results_sample2:0,
                    results_sample3:0,
                    results_sample4:0,
                    results_sample5:0,
                    state:'PENDING',
                    year:this.year.getFullYear().toString(),
                    reference:this.pt_session+this.month.toUpperCase()+this.year.getFullYear()
                },(d)=>{
                    window.location.href = '/ptround/vl-ptrounds'
                    console.log(d);
                },(e)=>{
                    console.log("error",e);
                },()=>{
                    this.loader=false
                    console.log("finishing");
                })
            },
            resetForm(){
                this.$refs['resForm'].reset()
            },
            selected(sValue){
                console.log(sValue.id)
                this.site_ids.push(sValue.id);
                console.log(this.site_ids)
            },
            removed(e){
               console.log(e)
                this.site_ids = this.site_ids.filter(el=>{
                    return el != e.id
                });
                console.log(this.site_ids)
            },
        },
        mounted() {
            this.user=JSON.parse(localStorage.getItem('user'))
            axios_get("/sites",{},(d)=>{
                this.options2=d.filter(e=>{return e.region.country_id==this.user.country_id && e.site_category=='VL'})
                //this.options2=this.siteData.map(e=>(e.site_name))
                },(e)=>{
                    console.log("error",e);
                },()=>{
                    console.log("finishing");
                }
            );
        }
    };
</script>

<style scoped>
    .lodader__content{
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, .1);
        width: 100%;
        height: 100%;
    }

    .loader{
        position: relative;
        left: 50%;
        top: 50%;
    }
</style>